module.exports = __webpack_public_path__ + "static/media/jochenBühling.6a724984.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/authorSpotlight/jochenBühling.jpg
// module id = 1571
// module chunks = 1